import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { enumUtil } from "../../../../utils/Enum"
import FormValidator from "../../../../utils/FormValidator"
import NotificationHandler from "../../../../utils/NotificationHandler"
import { GetZipCode, ServerRequestClearnigHouse, ServerRequestProtected } from "../../../../utils/ServerDataRequest"
import isNull from "../../../../utils/NullChecking"
import States, { PreferredCommunication, PreferredLanguage, PrimaryContactType, Relationship } from "../../../../utils/Constants"
import { EmploymentStatus, StudentStatus, Class, BirthOrder, GenderIdentity, SexualOrientation, BloodGroup } from '../../../../utils/Constants';
import { useSelector } from 'react-redux';
import { useState, useEffect } from 'react';
import format from 'date-fns/format';
////////
import { MaritalStatus } from '../../../../utils/Constants';
import Loader from '../../../shared/Loader/Loader';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { Gender } from '../../../../utils/Constants';
import { addDays } from 'date-fns';
import handleNumericCheck from '../../../../utils/HandleNumericKeys';
import SuperSearchList from '../../../shared/SuperSearch/SuperSearchList';
import { useDispatch } from 'react-redux';
import { CaregiverRecordAction, TabActionCaregiver } from '../../../../actions/CaregiverActions';
import { OpenNewCaregiverTabAction } from '../../../../actions/CaregiverActions';
import FormatDate from '../../../shared/DateFormatter';
import { Autocomplete, Switch, TextField } from '@mui/material';
import handleAlphabeticCheck from '../../../../utils/HandleAlphabetKeys';
import FormatPhoneNumber from '../../../../utils/FormatPhoneNumber';
import ReactInputMask from 'react-input-mask';
import DropdownValueHandler from '../../../shared/SuperSearch/DropdownValueHandler'
import DatePicker from '../../../General/DatePicker';
import { useMemo } from 'react';
import OpenQuickPopup from '../../../shared/OpenQuickPopup/OpenQuickPopup';
import SuperSearchMultiple from '../../../shared/SuperSearch/SuperSearchMultiple';
import { FindFirstChild } from '../../../../utils/FindMenuOption';
////////
const Races = [
    { value: '-1', display: '' },
    { value: 'Mexican', display: 'Mexican' },
    { value: 'Puerto Rican', display: 'Puerto Rican' },
    { value: 'Cuban', display: 'Cuban' },
    { value: 'Dominican', display: 'Dominican' },
    { value: 'Other Central American', display: 'Other Central American' },
    { value: 'Argentinean', display: 'Argentinean' },
    { value: 'Colombian', display: 'Colombian' },
    { value: 'Venezuelan', display: 'Venezuelan' },
    { value: 'Spaniard', display: 'Spaniard' },
    { value: 'Mexican', display: 'Mexican' },
    { value: 'Puerto Rican', display: 'Puerto Rican' },
    { value: 'Cuban', display: 'Cuban' },
    { value: 'Dominican', display: 'Dominican' },
    { value: 'Other Central American', display: 'Other Central American' },
    { value: 'Argentinean', display: 'Argentinean' },
    { value: 'Colombian', display: 'Colombian' },
    { value: 'Venezuelan', display: 'Venezuelan' },
    { value: 'Spaniard', display: 'Spaniard' },
];

const Ethnicity = [
    { value: '-1', display: '' },
    { value: 'Asian People', display: 'Asian People' },
    { value: 'African Americans', display: 'African Americans' },
    { value: 'White Peoples', display: 'White Peoples' },
    { value: 'Hispanic and Latino Americans', display: 'Hispanic and Latino Americans' },
    { value: 'Americans', display: 'Americans' },
    { value: 'Mixed', display: 'Mixed' },
    { value: 'Alaska Natives', display: 'Alaska Natives' },
    { value: 'Arabs', display: 'Arabs' },
    { value: 'Hispanic', display: 'Hispanic' },
    { value: 'Indian people', display: 'Indian people' },
    { value: 'Bouyei people', display: 'Bouyei people' },
    { value: 'Gelao people', display: 'Gelao people' },
    { value: 'Māori people', display: 'Māori people' },
    { value: 'Samoans', display: 'Samoans' },
    { value: 'Hani people', display: 'Hani people' },
    { value: 'Yao people', display: 'Yao people' },
    { value: 'Han Chinese', display: 'Han Chinese' },
    { value: 'Mongols', display: 'Mongols' },
    { value: 'Qiang people', display: 'Qiang people' },
    { value: 'Blackfoot Confederacy', display: 'Blackfoot Confederacy' },
    { value: 'Manchu people', display: 'Manchu people' },
    { value: 'Bai people', display: 'Bai people' },
    { value: 'Lisu people', display: 'Lisu people' },
    { value: 'Sui people', display: 'Sui people' },
    { value: 'Jingpo people', display: 'Jingpo people' },
    { value: 'Salar people', display: 'Salar people' },
    { value: 'Oroqen people', display: 'Oroqen people' },
    { value: 'Nanai people', display: 'Nanai people' },
    { value: 'Hlai people', display: 'Hlai people' },
    { value: 'Uzbeks', display: 'Uzbeks' },
    { value: 'Evenks', display: 'Evenks' },
    { value: 'Russian', display: 'Russian' },
    { value: 'Kyrgyz people', display: 'Kyrgyz people' },
    { value: 'Jewish people', display: 'Jewish people' },
    { value: 'Native Hawaiians', display: 'Native Hawaiians' },
    { value: 'Cherokee', display: 'Cherokee' },
    { value: 'Sioux', display: 'Sioux' },
    { value: 'Kongo people', display: 'Kongo people' },
    { value: 'Hutu', display: 'Hutu' },
    { value: 'Amhara people', display: 'Amhara people' },
    { value: 'Somalis', display: '' },
    { value: 'Oromo people', display: 'Oromo people' },
    { value: 'Irish people', display: 'Irish people' },
    { value: 'Nùng people', display: 'Nùng people' },
    { value: 'Romani people', display: 'Romani people' },
    { value: 'Fijians', display: 'Fijians' },
    { value: 'Irish Travellers', display: 'Irish Travellers' },
    { value: 'Serbs', display: 'Serbs' },
]

const Demographics = (props) => {
    const [isOpenMissing, setIsOpenMissing] = useState(false)
    const [missingData, setMissingData] = useState(false)
    const [missingDataInfo, setMissingDataInfo] = useState([])
    let DropdownData = useSelector(state => state.GeneralDropDownsReducer)
    let PateintIDR = useSelector(state => state.Open_Caregiver_Tab.find((pt) => pt.active === true));
    PateintIDR = PateintIDR?.data?.id
    let reduxData = useSelector(state => state.Open_Caregiver_Tab)
    let CaregiverData = useSelector(state => state.CaregiverRecordReducer);
    let IsEditAllowed = FindFirstChild('CareGiver', 'Demographics')?.IsAdd

    // let tabId =useSelector(state => state.Open_Caregiver_Tab.map((pt)=> pt.data.id));
    let Caregiver_Modal = {
        ProfilePicture: "",
        AccountNumber: '',
        LastName: '',
        FirstName: '',
        MedicareNo: '',
        MedicaidNo: '',
        PreviousName: '',
        PreferredName: '',
        SSN: '',
        Gender: '',
        MI: '',
        MaritalStatus: '',
        DateOfBirth: null,
        Age: '',
        AddressLine1: '',
        AddressLine2: '',
        City: '',
        State: '',
        ZipCode: '',
        HomePhoneNumber: '',
        MobileNumber: '',
        WorkNumber: '',
        WorkPhoneExtention: '',
        OtherPhoneNumber: '',
        Email: '',
        FaxNumber: '',
        PrimaryContactType: '',
        PreferredLanguage: '',
        PreferredCommunication: '',
        LocationID: '',
        LocationName: '',
        ProviderID: '',
        RefProviderID: '',
        PharmacyID: '',
        EmployerID: '',
        EmploymentStatus: '',
        StudentStatus: '',
        Class: '',
        Race: '',
        Ethnicity: '',
        BirthCity: '',
        BirthOrder: '',
        GenderIdentity: '',
        SexualOrientation: '',
        EmergencyPhoneNumber: '',
        EmergencyOtherPhoneNumber: '',
        DateOfDeath: null,
        CauseOfDeath: '',
        CaregiverReferralSource: '',
        BloodGroup: '',
        MotherFirstName: '',
        MotherMedianName: '',
        HispanicOrLatino: '',
        MaidenLastName: '',
        MultipleBirth: '',
        Pregnancy: '',
        IsDeceased: '',
        SignatureOnFile: '',
        ReleaseOfFile: '',
        Statuss: '',
        ErrorMessages: '',
        CreatedBy: '',
        CreatedDate: '',
    }

    let valModal = {}
    let ValidationModal = {
        FirstNameVal: "",
        LastNameVal: "",
        GenderVal: "",
        DateOfBirthVal: "",
        SSNLengthVal: "",
        ZipCodeLengthVal: "",
        HomePhoneNumberlen: "",
        MobileNumberlen: "",
        WorkNumberlen: "",
        WorkPhoneExtentionlen: "",
        OtherPhoneNumberlen: "",
        EmergencyOtherPhoneNumberlen: "",
        FaxNumberlen: "",
        EmailAddressVal: "",
        MIval: "",
        ZipCodeVal: "",
        SSNval: "",
        EmployementStatusval: "",
        EmployementDateval: ""
    }

    // let valModalEmployementInfoCaregiver = {}
    // let EmployementInfoCaregiver_ValidationModal = {
    //     EmployementStatus: "",
    //     Date: null,
    //     Discipline: "",
    //     Notes: ""
    // }
    // const [employementInfoCaregiverValidationModal, setEmployementInfoCaregiverValidationModal] = useState(EmployementInfoCaregiver_ValidationModal)


    let EmployementInfoCaregiver_Modal = {
        EmployementStatusID: "0",
        EmployementStatus: "",
        Date: null,
        Discipline: "",
        Notes: ""
    }
    const [range, setRange] = useState([
        {
            startDate: null,
            endDate: addDays(new Date(), 7),
            // endDate: null,
            key: 'selection'
        }
    ])
    const { mainClaimModal, handlePateintChange, handleClaimsChange, patientBody, handleSelectedClaimInfoData,
        ClaimInfoVal, isReadOnly, ProviderID, RefProviderID, POScode, BillingProviderID, handleSelectRecentPateint } = { ...props }
    const [isLoading, setIsLoading] = useState(false)
    const [disciplineData, setDisciplineData] = useState([])
    const [CaregiverValidationModal, setCaregiverValidationModal] = useState(ValidationModal)
    const [CaregiverID, setCaregiverID] = useState()
    const [CaregiverSaveUpdateModal, setCaregiverSaveUpdateModal] = useState({})
    const API_URL = enumUtil.controller.PATIENT
    const API_URL_Caregiver = enumUtil.controller.CareGiver
    const API_URL_General = enumUtil.controller.General
    const API_URL_CH = enumUtil.controller.EDI
    const [mainCaregiverModal, setMainCaregiverModal] = useState(Caregiver_Modal);
    const [mainEmployementInfoCaregiverModal, setMainEmployementInfoCaregiverModal] = useState(EmployementInfoCaregiver_Modal);
    const [otherCaregiverID, setEmployementInfoCaregiverID] = useState("0")
    const [employementInfoCaregiverSaveUpdateModal, setEmployementInfoCaregiverSaveUpdateModal] = useState({})

    let DropDowns = useSelector(state => state.GeneralDropDownsReducer);
    const [newCaregiverSaved, setNewCaregiverSaved] = useState(false);
    const [is, setIs] = useState(false);
    const [race, setRace] = useState([])
    const [ethnicity, setEthnicity] = useState([])
    const [expanded, setExpanded] = useState('Pateint1-content');
    const [LocationID, setLocationID] = useState('LocationID');
    const [locationID, setlocationID] = useState('');
    const [providerID, setProviderID] = useState('');
    const [RefproviderID, setRefProviderID] = useState('');

    let dispatch = useDispatch();
    const LoadDemographics = () => {
        setIs(true)
        if (CaregiverID === 0) {
            setMainCaregiverModal({
                ...mainCaregiverModal,
                LocationID: DropDowns?.Location.length === 2 ? DropDowns?.Location[1].display : '',
                ProviderID: DropDowns?.Provider.length === 2 ? DropDowns?.Provider[1].display : '',
                Statuss: true
            })
            setCaregiverSaveUpdateModal({
                ...CaregiverSaveUpdateModal,
                LocationID: DropDowns?.Location.length === 2 ? DropDowns?.Location[1].value + "" : '-1',
                ProviderID: DropDowns?.Provider.length === 2 ? DropDowns?.Provider[1].value + "" : '-1',
                Statuss: "true"
            })
            // if (DropDowns?.Location.length === 2) {
            //     setCaregiverSaveUpdateModal({ ...CaregiverSaveUpdateModal, LocationID: DropDowns?.Location[1].value + "" })
            // }
            // if (DropDowns?.Provider.length === 2) {
            //     setCaregiverSaveUpdateModal({ ...CaregiverSaveUpdateModal, ProviderID: DropDowns?.Provider[1].value + "" })
            // }
            // setCaregiverSaveUpdateModal({ ...CaregiverSaveUpdateModal, Statuss: 'true' })
        }
        ////Updating Opened Caregiver Id///
        if (PateintIDR === -1) {
            if (!newCaregiverSaved) { setCaregiverID(0) }
        } else { setCaregiverID(PateintIDR) }
        //////
        setIsLoading(false)
        if (!isNull(CaregiverID)) {
            setIsLoading(true)
            // setIsLoading(true)
            ServerRequestProtected(API_URL_Caregiver + "/FindCareGiverByID", 'post', {
                "ID": CaregiverID,
                "TableName": enumUtil.enumAPITableName.Caregiver
            }).then((response) => {
                setMainEmployementInfoCaregiverModal({})
                response.State = DropdownValueHandler(States, response.State)
                response.Gender = DropdownValueHandler(Gender, response.Gender)

                response.LocationID = DropdownValueHandler(DropDowns?.Location, response.LocationID)
                response.ProviderID = DropdownValueHandler(DropDowns?.Provider, response.ProviderID)
                response.RefProviderID = DropdownValueHandler(DropDowns?.RefProvider, response.RefProviderID)
                response.PrimaryOffice = DropdownValueHandler(DropDowns?.Location, response.PrimaryOffice)
                if (!isNull(response.MobileNumber)) {
                    response.MobileNumber = FormatPhoneNumber(response.MobileNumber)
                }
                if (!isNull(response.WorkNumber)) {
                    response.WorkNumber = FormatPhoneNumber(response.WorkNumber)
                }
                if (!isNull(response.OtherPhoneNumber)) {
                    response.OtherPhoneNumber = FormatPhoneNumber(response.OtherPhoneNumber)
                }
                if (!isNull(response.HomePhoneNumber)) {
                    response.HomePhoneNumber = FormatPhoneNumber(response.HomePhoneNumber)
                }
                setMainCaregiverModal({
                    ...response, DateOfBirth: !isNull(response.DateOfBirth) ? FormatDate(response.DateOfBirth) : null,
                    DateOfDeath: !isNull(response.DateOfDeath) ? FormatDate(response.DateOfDeath) : null
                })
                let racee = !isNull(response.Race) ? response.Race.split(',') : ''
                let racearr = []
                if (racee.length > 0) {
                    racee.map((item) => {
                        racearr.push({ value: item, display: item })
                    })
                }
                let eth = !isNull(response.Ethnicity) ? response.Ethnicity.split(',') : ''
                let ethar = [];
                if (eth.length > 0) {
                    eth.map((item) => {
                        ethar.push({ value: item, display: item })
                    })
                }
                if (!isNull(response.ErrorMessages)) {
                    let splitedData = response.ErrorMessages.split(';')
                    setMissingDataInfo(splitedData)
                }

                setRace(racearr)
                setEthnicity(ethar)
                setEmployementInfoCaregiverID(response?.OtherData?.ID || "0")
                setMainEmployementInfoCaregiverModal(response?.OtherData)
                setIsLoading(false)
            }).catch((error) => {
                NotificationHandler(error.message, enumUtil.enumtoaster.error)
                setIsLoading(false)
            })
        }
    }
    useEffect(() => {
        setlocationID(locationID)
        setProviderID(ProviderID)
        setRefProviderID(RefProviderID)
        LoadDisciplineDD()
        LoadDemographics()
    }, [CaregiverID])
    useEffect(() => {
        setlocationID(locationID)
        setProviderID(ProviderID)
        setRefProviderID(RefProviderID)
        if (!isNull(props.Reload)) {
            let data = props.id
            data.map((item) => {
                if (item.key === 212) {
                    LoadDisciplineDD()
                    LoadDemographics()
                }
            })
            if (data.length === 0) {
                LoadDisciplineDD()
                LoadDemographics()
            }
        }
    }, [props.Reload, LocationID, ProviderID, RefProviderID])
    const handleChangeAccodian = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
        if (!isExpanded && panel === 'other') {
            setExpanded('Pateint1-content');
        }
        if (!isExpanded && panel === 'Pateint1-content') {
            setExpanded('other');
        }
    };
    const CaregiverValidation = async () => {
        let faxNumber = "";
        let OtherPhonenumber = "";
        let EmergencyOtherPhoneNumber = "";
        let HomeNmber = "";
        let MobileContact = "";
        let Workcontact = "";
        let EmpInfoVal = true;
        if (!isNull(mainCaregiverModal.FaxNumber)) {
            faxNumber = mainCaregiverModal.FaxNumber.replace(/-/g, "");
        }
        if (!isNull(mainCaregiverModal.OtherPhoneNumber)) {
            OtherPhonenumber = mainCaregiverModal.OtherPhoneNumber.replace(/[()-\s]/g, '');
        }
        if (!isNull(mainCaregiverModal.EmergencyOtherPhoneNumber)) {
            EmergencyOtherPhoneNumber = mainCaregiverModal.EmergencyOtherPhoneNumber.replace(/[()-\s]/g, '');
        }
        if (!isNull(mainCaregiverModal.HomePhoneNumber)) {
            HomeNmber = mainCaregiverModal.HomePhoneNumber.replace(/[()-\s]/g, '');
        }
        if (!isNull(mainCaregiverModal.MobileNumber)) {
            MobileContact = mainCaregiverModal.MobileNumber.replace(/[()-\s]/g, '');
        }
        if (!isNull(mainCaregiverModal.WorkNumber)) {
            Workcontact = mainCaregiverModal.WorkNumber.replace(/[()-\s]/g, '');
        }
        if (isNull(mainEmployementInfoCaregiverModal.EmployementStatus) &&
            isNull(mainEmployementInfoCaregiverModal.Date) &&
            isNull(mainEmployementInfoCaregiverModal.Discipline) &&
            isNull(mainEmployementInfoCaregiverModal.Notes)) {
            EmpInfoVal = false
        }
        let genderVal = mainCaregiverModal.Gender === "-1" ? "" : mainCaregiverModal.Gender;
        let ValidationModal = {
            FirstNameVal: FormValidator(
                mainCaregiverModal.FirstName,
                enumUtil.enumValidationType.Required,
                'First Name',
            ),
            LastNameVal: FormValidator(
                mainCaregiverModal.LastName,
                enumUtil.enumValidationType.Required,
                'Last Name',
            ),
            GenderVal: FormValidator(
                genderVal,
                enumUtil.enumValidationType.Required,
                'Gender',
            ),
            DateOfBirthVal: FormValidator(
                mainCaregiverModal.DateOfBirth,
                enumUtil.enumValidationType.Required,
                'DOB',
            ),
            SSNLengthVal: FormValidator(
                mainCaregiverModal.SSN,
                enumUtil.enumValidationType.Length,
                'SSN',
                9
            ),
            ZipCodeLengthVal: FormValidator(
                mainCaregiverModal.ZipCode,
                enumUtil.enumValidationType.Lengths,
                'Zip Code',
                5, 9
            ),
            HomePhoneNumberlen: FormValidator(
                HomeNmber,
                enumUtil.enumValidationType.Length,
                'Home Number',
                10
            ),
            MobileNumberlen: FormValidator(
                MobileContact,
                enumUtil.enumValidationType.Length,
                'Mobile Number',
                10
            ),
            WorkPhoneExtentionlen: FormValidator(
                mainCaregiverModal.WorkPhoneExtention,
                enumUtil.enumValidationType.Length,
                'Work Extension',
                4
            ),
            OtherPhoneNumberlen: FormValidator(
                OtherPhonenumber,
                enumUtil.enumValidationType.Length,
                'Other Number',
                10
            ),
            EmergencyOtherPhoneNumberlen: FormValidator(
                EmergencyOtherPhoneNumber,
                enumUtil.enumValidationType.Length,
                'Emergency Other Number',
                10
            ),
            FaxNumberlen: FormValidator(
                faxNumber,
                enumUtil.enumValidationType.Length,
                'Fax Number',
                10
            ),
            EmailAddressVal: FormValidator(
                mainCaregiverModal.Email,
                enumUtil.enumValidationType.Email,
                'Email',
            ),
            WorkNumberlen: FormValidator(
                Workcontact,
                enumUtil.enumValidationType.Length,
                'Work Number',
                10
            ),
            ZipCodeVal: FormValidator(
                mainCaregiverModal.ZipCode,
                enumUtil.enumValidationType.Digit,
                'Zip Code'
            ),
            MIval: FormValidator(
                mainCaregiverModal.MI,
                enumUtil.enumValidationType.Alphabet,
                'MI'
            ),
            ...(EmpInfoVal ? {
                EmployementStatusval: FormValidator(
                    mainEmployementInfoCaregiverModal.EmployementStatus,
                    enumUtil.enumValidationType.Required,
                    'Employement Status'
                ),
                EmployementDateval: FormValidator(
                    mainEmployementInfoCaregiverModal.Date,
                    enumUtil.enumValidationType.Required,
                    'Date'
                )
            } : {})
        }
        await setCaregiverValidationModal(ValidationModal)
        valModal = ValidationModal
        console.log("Console", mainEmployementInfoCaregiverModal.EmployementStatus,)

    }
    // const EmployementInfoCaregiverValidation = async () => {
    //     let faxNumber = "";
    //     let OtherPhonenumber = "";
    //     let HomeNmber = "";
    //     let MobileContact = "";
    //     let Workcontact = "";
    //     if (!isNull(mainCaregiverModal.FaxNumber)) {
    //         faxNumber = mainCaregiverModal.FaxNumber.replace(/-/g, "");
    //     }
    //     if (!isNull(mainCaregiverModal.OtherPhoneNumber)) {
    //         OtherPhonenumber = mainCaregiverModal.OtherPhoneNumber.replace(/[()-\s]/g, '');
    //     }
    //     if (!isNull(mainCaregiverModal.HomePhoneNumber)) {
    //         HomeNmber = mainCaregiverModal.HomePhoneNumber.replace(/[()-\s]/g, '');
    //     }
    //     if (!isNull(mainCaregiverModal.MobileNumber)) {
    //         MobileContact = mainCaregiverModal.MobileNumber.replace(/[()-\s]/g, '');
    //     }
    //     if (!isNull(mainCaregiverModal.WorkNumber)) {
    //         Workcontact = mainCaregiverModal.WorkNumber.replace(/[()-\s]/g, '');
    //     }
    //     let ValidationModal = {
    //         FirstNameVal: FormValidator(
    //             mainCaregiverModal.FirstName,
    //             enumUtil.enumValidationType.Required,
    //             'First Name',
    //         ),
    //         LastNameVal: FormValidator(
    //             mainCaregiverModal.LastName,
    //             enumUtil.enumValidationType.Required,
    //             'Last Name',
    //         ),
    //         GenderVal: FormValidator(
    //             mainCaregiverModal.Gender,
    //             enumUtil.enumValidationType.Required,
    //             'Gender',
    //         ),
    //         DateOfBirthVal: FormValidator(
    //             mainCaregiverModal.DateOfBirth,
    //             enumUtil.enumValidationType.Required,
    //             'DateOfBirth',
    //         ),
    //         SSNLengthVal: FormValidator(
    //             mainCaregiverModal.SSN,
    //             enumUtil.enumValidationType.Length,
    //             'SSN',
    //             9
    //         ),
    //         ZipCodeLengthVal: FormValidator(
    //             mainCaregiverModal.ZipCode,
    //             enumUtil.enumValidationType.Lengths,
    //             'Zip Code',
    //             5, 9
    //         ),
    //         HomePhoneNumberlen: FormValidator(
    //             HomeNmber,
    //             enumUtil.enumValidationType.Length,
    //             'Home Number',
    //             10
    //         ),
    //         MobileNumberlen: FormValidator(
    //             MobileContact,
    //             enumUtil.enumValidationType.Length,
    //             'Mobile Number',
    //             10
    //         ),
    //     }
    //     await setCaregiverValidationModal(ValidationModal)
    //     valModal = ValidationModal

    // }
    const LoadDisciplineDD = () => {
        ServerRequestProtected(API_URL_General + "/DropDown", 'post', {
            "TableName": enumUtil.enumAPITableName.Discipline
        })
            .then((response) => {
                setDisciplineData(response)
            }).catch((error) => {
            })
    }
    const handleCaregiverChange = (e) => {
        setIs(true)
        let { name, value } = e.target;
        if (process.env.REACT_APP_ISUPPERCASE === "true") {
            value = value.toUpperCase()
        }
        let modal = { ...mainCaregiverModal };
        let saveModal = { ...CaregiverSaveUpdateModal }
        if (name === "MultipleBirth" || name === 'Pregnancy' || name === 'IsDeceased' || name === 'SignatureOnFile' || name === 'ReleaseOfFile' || name === 'Statuss') {
            modal[name] = !modal[name]
        }
        else if (name === 'OtherPhoneNumber' || name === 'EmergencyOtherPhoneNumber' || name === 'MobileNumber' || name === 'WorkNumber' || name === 'HomePhoneNumber' || name === 'EmergencyPhoneNumber') {
            const formattedValue = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            modal[name] = !formattedValue[2] ? formattedValue[1] : `(${formattedValue[1]}) ${formattedValue[2]}${formattedValue[3] ? '-' + formattedValue[3] : ''}`;
        }
        else if (name === 'ZipCode') {
            console.log("ehandleCaregiverChangeelseif", name, value)
            GetZipCode(value)
                .then(data => {
                    setMainCaregiverModal(prevState => ({ ...prevState, ...data?.main }));
                    setCaregiverSaveUpdateModal(prevState => ({ ...prevState, ...data?.save }));
                })
                .catch(error => {
                });
            modal[name] = value;
        }
        else {
            modal[name] = value
        }
        setMainCaregiverModal(modal)
        for (var property in Caregiver_Modal) {
            if (name === property) {
                if (name === "MultipleBirth" || name === 'Pregnancy' || name === 'IsDeceased' || name === 'SignatureOnFile' || name === 'ReleaseOfFile' || name === 'Statuss') {
                    saveModal[name] = modal[name] + ""
                } else {
                    saveModal[name] = value
                }
            }
        }
        setCaregiverSaveUpdateModal(saveModal)
    }

    const handleEmployementInfoCaregiverDataChange = (e) => {
        setIs(true)
        let { name, value } = e.target;
        let modal = { ...mainEmployementInfoCaregiverModal };
        let saveModal = { ...employementInfoCaregiverSaveUpdateModal };
        // if (process.env.REACT_APP_ISUPPERCASE === "true") {
        //     value = value.toUpperCase()
        // }
        // let modal = { ...mainEmployementInfoCaregiverModal };
        // let saveModal = { ...CaregiverSaveUpdateModal }
        // if (name === "MultipleBirth" || name === 'Pregnancy' || name === 'IsDeceased' || name === 'SignatureOnFile' || name === 'ReleaseOfFile' || name === 'Statuss') {
        //     modal[name] = !modal[name]
        // }
        // else if (name === 'MobileNumber') {
        //     const formattedValue = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        //     modal[name] = !formattedValue[2] ? formattedValue[1] : '(' + formattedValue[1] + ') ' + formattedValue[2] + (formattedValue[3] ? '-' + formattedValue[3] : '');
        // }
        // else if (name === 'WorkNumber') {
        //     const formattedValue = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        //     modal[name] = !formattedValue[2] ? formattedValue[1] : '(' + formattedValue[1] + ') ' + formattedValue[2] + (formattedValue[3] ? '-' + formattedValue[3] : '');
        // }
        // else if (name === 'EmployementInfoPhoneNumber') {
        //     const formattedValue = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        //     modal[name] = !formattedValue[2] ? formattedValue[1] : '(' + formattedValue[1] + ') ' + formattedValue[2] + (formattedValue[3] ? '-' + formattedValue[3] : '');
        // }
        // else if (name === 'HomePhoneNumber') {
        //     const formattedValue = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        //     modal[name] = !formattedValue[2] ? formattedValue[1] : '(' + formattedValue[1] + ') ' + formattedValue[2] + (formattedValue[3] ? '-' + formattedValue[3] : '');
        // }
        // else if (name === 'ZipCode') {
        //     GetZipCode(value)
        //         .then(data => {
        //             setMainCaregiverModal(prevState => ({...prevState,...data?.main}));
        //             setCaregiverSaveUpdateModal(prevState => ({...prevState,...data?.save}));
        //         })
        //         .catch(error => {
        //         });
        //     modal[name] = value;
        // }
        // else {
        //     modal[name] = value
        // }
        setMainEmployementInfoCaregiverModal(modal)
        for (var property in Caregiver_Modal) {
            if (name === property) {
                // if (name === "MultipleBirth" || name === 'Pregnancy' || name === 'IsDeceased' || name === 'SignatureOnFile' || name === 'ReleaseOfFile' || name === 'Statuss') {
                //     saveModal[name] = modal[name] + ""
                // } else {
                saveModal[name] = value
                // }
            }
        }
        setEmployementInfoCaregiverSaveUpdateModal(saveModal)
    }
    const handleChangeDD = (e) => {
        setIs(false)
        let { name, value } = e.target;
        let modal = { ...mainCaregiverModal };
        modal[name] = value
        setMainCaregiverModal(modal)
    }
    const handleSaveCaregiver = async () => {
        if (IsEditAllowed) {
            await CaregiverValidation()
            let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
            if (validation) {
                NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
                return
            } else {
                if (!isNull(CaregiverSaveUpdateModal.FaxNumber)) {
                    CaregiverSaveUpdateModal['FaxNumber'] = CaregiverSaveUpdateModal.FaxNumber.replace(/-/g, "");
                }
                if (!isNull(CaregiverSaveUpdateModal.MobileNumber)) {
                    CaregiverSaveUpdateModal['MobileNumber'] = CaregiverSaveUpdateModal.MobileNumber.replace(/[()-\s]/g, "");
                    CaregiverSaveUpdateModal.MobileNumber = CaregiverSaveUpdateModal.MobileNumber.slice(0, 10);
                }
                if (!isNull(CaregiverSaveUpdateModal.WorkNumber)) {
                    CaregiverSaveUpdateModal['WorkNumber'] = CaregiverSaveUpdateModal.WorkNumber.replace(/[()-\s]/g, "");
                    CaregiverSaveUpdateModal.WorkNumber = CaregiverSaveUpdateModal.WorkNumber.slice(0, 10);
                }
                if (!isNull(CaregiverSaveUpdateModal.OtherPhoneNumber)) {
                    CaregiverSaveUpdateModal['OtherPhoneNumber'] = CaregiverSaveUpdateModal.OtherPhoneNumber.replace(/[()-\s]/g, "");
                    CaregiverSaveUpdateModal.OtherPhoneNumber = CaregiverSaveUpdateModal.OtherPhoneNumber.slice(0, 10);
                }
                if (!isNull(CaregiverSaveUpdateModal.HomePhoneNumber)) {
                    CaregiverSaveUpdateModal['HomePhoneNumber'] = CaregiverSaveUpdateModal.HomePhoneNumber.replace(/[()-\s]/g, "");
                    CaregiverSaveUpdateModal.HomePhoneNumber = CaregiverSaveUpdateModal.HomePhoneNumber.slice(0, 10);
                }
                // setCaregiverSaveUpdateModal(CaregiverSaveUpdateModal)
                let otherData = true;
                if (isNull(mainEmployementInfoCaregiverModal.EmployementStatus) &&
                    isNull(mainEmployementInfoCaregiverModal.Date) &&
                    isNull(mainEmployementInfoCaregiverModal.Discipline) &&
                    isNull(mainEmployementInfoCaregiverModal.Notes)) {
                    otherData = false;
                }
                let saveModal = {
                    TableName: enumUtil.enumAPITableName.Caregiver,
                    ID: CaregiverID + "",
                    data: { ...CaregiverSaveUpdateModal },
                    ...(otherData ? { OtherData: { "EmployementStatusID": otherCaregiverID, ...employementInfoCaregiverSaveUpdateModal } } : {}),
                    value: null
                }
                setIsLoading(true)
                ServerRequestProtected(API_URL_Caregiver + "/SaveCareGiverRecord", 'post', saveModal)
                    .then((response) => {
                        if (!isNull(response.id)) {
                            setIsLoading(false)
                            setMainEmployementInfoCaregiverModal(EmployementInfoCaregiver_Modal)
                            setEmployementInfoCaregiverSaveUpdateModal({})
                            NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
                            setNewCaregiverSaved(true)
                            setCaregiverID(response.id - "")
                            handleMissingData(response.id)
                            if (PateintIDR === -1) {
                                let newItem = { ID: response.id, name: CaregiverSaveUpdateModal.FirstName, FullName: CaregiverSaveUpdateModal.FirstName + ', ' + CaregiverSaveUpdateModal.LastName + ', ', AccountNumber: CaregiverSaveUpdateModal.AccountNumber ? CaregiverSaveUpdateModal.AccountNumber : '' }
                                let data = [...CaregiverData, newItem]
                                dispatch(CaregiverRecordAction(data))
                                let obj = {
                                    key: 2,
                                    name: "Caregiver",
                                    active: true,
                                    data: {
                                        id: response.id - "",
                                        name: CaregiverSaveUpdateModal.FirstName,
                                        newCaregiver: true
                                    },
                                };
                                let updatedData = reduxData.map((item, index) => {
                                    if (item.data.id === -1 && PateintIDR === -1) {
                                        return item = obj
                                    } else {
                                        return item
                                    }
                                })
                                dispatch(OpenNewCaregiverTabAction(updatedData))

                            }
                        }
                    }).catch((error) => {
                        setIsLoading(false)
                        NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                    })
            }
        }
    }
    // const handleRangeChange = (date) => {
    //     mainCaregiverModal.DateOfBirth = format(date[0].startDate, 'yyyy/MM/dd') + ' to ' + format(date[0].endDate, 'yyyy/MM/dd')
    //     CaregiverSaveUpdateModal['DateOfBirth'] = mainCaregiverModal.DateOfBirth
    //     setRange(date)
    //     // setShowCalendar(false)
    // }
    const calculateAge = (birthDate) => {
        const currentDate = new Date();
        let years = currentDate.getFullYear() - birthDate.getFullYear();
        let months = currentDate.getMonth() - birthDate.getMonth();
        if (months < 0) {
            years = years - 1
            months = months + 12
        }
        return years + ' years and ' + months + ' months'
    };
    const handleCalendarChange = (date, type) => {
        var FormatedDate = date
        let modal = { ...mainCaregiverModal };
        let saveModal = { ...CaregiverSaveUpdateModal }
        modal[type] = FormatedDate
        if (type === 'DateOfBirth') {
            date?.length === 0 ?
                modal['Age'] = '' :
                modal['Age'] = calculateAge(date)
        }
        setMainCaregiverModal(modal)
        for (var property in Caregiver_Modal) {
            if (type === property) {
                saveModal[type] = FormatedDate
            }
        }
        setCaregiverSaveUpdateModal(saveModal)
    }

    const handleDeleteEmployementInfo = (item, index) => {
        setIsLoading(true)
        ServerRequestProtected(API_URL_General + "/DeleteSingleRecord", 'post', {
            "ID": item?.EmployementStatusID,
            "TableName": enumUtil.enumAPITableName.EmployementStatus,
        },)
            .then((response) => {
                let data = [...mainCaregiverModal?.OtherData];
                data.splice(index, 1);
                setMainCaregiverModal(prev => ({ ...prev, OtherData: data }));
                setIsLoading(false)
            })
            .catch((error) => {
                setIsLoading(false)
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
            })
    };

    const handleEmployementInfoCalendarChange = (date, type) => {
        var FormatedDate = date
        let modal = { ...mainEmployementInfoCaregiverModal };
        let saveModal = { ...employementInfoCaregiverSaveUpdateModal }
        modal[type] = FormatedDate
        if (type === 'DateOfBirth') {
            modal['Age'] = calculateAge(date)
        }
        setMainEmployementInfoCaregiverModal(modal)
        for (var property in EmployementInfoCaregiver_Modal) {
            if (type === property) {
                saveModal[type] = FormatedDate
            }
        }
        setEmployementInfoCaregiverSaveUpdateModal(saveModal)
    }
    const handleCaregiverProfileChange = (e) => {
        const Type = e.target.files[0].type.substring(0, 5);
        if (Type === 'image') {
            let file = e.target.files[0]
            let reader = new FileReader();

            reader.onloadend = () => {
                let value = reader.result.toString();
                let { name } = e.target;
                let modal = { ...mainCaregiverModal };
                let saveModal = { ...CaregiverSaveUpdateModal }
                modal[name] = value
                setMainCaregiverModal(modal)
                for (var property in Caregiver_Modal) {
                    if (name === property) {
                        saveModal[name] = value
                    }
                }
                setCaregiverSaveUpdateModal(saveModal)
            }
            reader.readAsDataURL(file);
        }
    }

    const handleEmployementInfoSelectedData = (selectedData, name, type, mode) => {
        let modal = { ...mainEmployementInfoCaregiverModal };
        if (type === 'client' && !isNull(selectedData)) {
            modal[name] = selectedData.display
            employementInfoCaregiverSaveUpdateModal[name] = selectedData.value + "";
            // }
            // else if (name === 'LocationID') {
            // modal[name] = selectedData.display
            // CaregiverSaveUpdateModal[name] = selectedData.value + "";
            // }
            // else if (name === 'ProviderID') {
            // modal[name] = selectedData.display
            // CaregiverSaveUpdateModal[name] = selectedData.value + "";
            // }
            // else if (name === 'RefProviderID') {
            // modal[name] = selectedData.display
            // CaregiverSaveUpdateModal[name] = selectedData.value + "";
            // } else if (name === 'Ethnicity') {
            // modal[name] = selectedData.display
            // CaregiverSaveUpdateModal[name] = selectedData.value + "";
            // } else if (name === 'Race') {
            // modal[name] = selectedData.display
            // CaregiverSaveUpdateModal[name] = selectedData.value + "";
            // } 
            if (name === "LocationID" && !isNull(selectedData)) {
                setlocationID(selectedData.value + "")
            }
            if (name === "ProviderID" && !isNull(selectedData)) {
                setProviderID(selectedData.value + "")
            }
            if (name === "RefProviderID" && !isNull(selectedData)) {
                setRefProviderID(selectedData.value + "")
            }
        } else if (type === 'server' && !isNull(selectedData)) {
            // if (name === 'POSCode') {
            //     LocationSaveUpdateModal[name] = selectedData.ID
            //     setPOS(selectedData.ID)


        } else {

            modal[name] = ''
            employementInfoCaregiverSaveUpdateModal[name] = ''
        }
        setMainEmployementInfoCaregiverModal(modal)
        setEmployementInfoCaregiverSaveUpdateModal(employementInfoCaregiverSaveUpdateModal)
        return selectedData
    }

    const handleSelectedData = (selectedData, name, type, mode) => {
        let modal = { ...mainCaregiverModal };
        if (type === 'client' && !isNull(selectedData)) {
            modal[name] = selectedData.display
            CaregiverSaveUpdateModal[name] = selectedData.value + "";
            // }
            // else if (name === 'LocationID') {
            // modal[name] = selectedData.display
            // CaregiverSaveUpdateModal[name] = selectedData.value + "";
            // }
            // else 
            if (name === 'Ethnicity') {
                modal[name] = selectedData.display
                CaregiverSaveUpdateModal[name] = selectedData.value + "";
            }
            if (name === 'MaritalStatus') {
                modal[name] = selectedData.display
                CaregiverSaveUpdateModal[name] = selectedData.value + "";
            }

            if (name === 'Gender') {
                modal[name] = selectedData.display
                CaregiverSaveUpdateModal[name] = selectedData.value + "";
            }
            if (name === 'Departments') {
                modal[name] = selectedData.display
                CaregiverSaveUpdateModal[name] = selectedData.value + "";
            }
            if (name === "LocationID" && !isNull(selectedData)) {
                setlocationID(selectedData.value + "")
            }
            if (name === "ProviderID" && !isNull(selectedData)) {
                setProviderID(selectedData.value + "")
            }
            if (name === "RefProviderID" && !isNull(selectedData)) {
                setRefProviderID(selectedData.value + "")
            }
        } else if (type === 'server' && !isNull(selectedData)) {
            // if (name === 'POSCode') {
            //     LocationSaveUpdateModal[name] = selectedData.ID
            //     setPOS(selectedData.ID)


        } else {

            modal[name] = ''
            CaregiverSaveUpdateModal[name] = ''
        }
        setMainCaregiverModal(modal)

        return selectedData
    }
    const handleGenderCheck = (e) => {
        let value = e.target.value
        ServerRequestClearnigHouse(API_URL_CH + "/CheckGender", 'post', {
            "Value": value,
            "TableName": enumUtil.enumAPITableName.CaregiverDMGData
        }).then((response) => {
            mainCaregiverModal.Gender = response.result
            setIsLoading(false)
        }).catch((error) => {
            // NotificationHandler(error.message, enumUtil.enumtoaster.error)
            setIsLoading(false)
        })
    }
    const handleMultipleSelect = (value, type) => {
        let RaceData = [];
        let EthicityData = [];
        if (type === 'Race') {
            value.map((key, index) => {
                RaceData.push(key.value)
            })
            setCaregiverSaveUpdateModal({
                ...CaregiverSaveUpdateModal, Race: RaceData.toString()
            })
            setRace(value)
        } else if (type === 'Ethnicity') {
            value.map((key, index) => {
                EthicityData.push(key.value)
            })
            setCaregiverSaveUpdateModal({
                ...CaregiverSaveUpdateModal, Ethnicity: EthicityData.toString()
            })
            setEthnicity(value)
        }
    }
    const handleMissingData = (ID) => {
        setIsLoading(true)
        ServerRequestProtected(API_URL + "/CaregiverReview", 'post', {
            "ID": ID,
            "TableName": enumUtil.enumAPITableName.PATIENTVALIDATION
        }).then((response) => {
            setIsLoading(false)
            setMissingData(true)
            let splitedData = response.split(';')
            setMissingDataInfo(splitedData)
        }).catch((error) => {
            // NotificationHandler(error.message, enumUtil.enumtoaster.error)
            setIsLoading(false)
            setMissingData(false)
        })

    }
    const handleOpenMissingData = () => {
        setIsOpenMissing(true)
    }
    const handleMultiSelect = (selectedDataArray, name, type, setModal, setSaveUpdateModal) => {
        let modal = { ...setModal() };
        let newDataObject = {};

        selectedDataArray.forEach(selectedData => {
            //   if (type === 'client' && !isNull(seleyctedData)) {
            modal[name] = selectedData.display;
            setSaveUpdateModal(prevModal => ({ ...prevModal, [name]: selectedData.value + "" }));
            newDataObject[name] = !isNull(selectedData) ? selectedData.value + "" : '';
        });
        setModal(modal);
        return newDataObject;
    };
    const [popup, setPopup] = useState(<></>);
    let LocationPopup = useMemo(() => { return <OpenQuickPopup ID={locationID + ""} name={'Location'} setPopup={setPopup} popupName={'Location'} type={"Label"} /> }, [mainCaregiverModal])
    let ProviderPopup = useMemo(() => { return <OpenQuickPopup ID={providerID + ""} name={'Provider'} setPopup={setPopup} popupName={'Provider'} type={"Label"} /> }, [mainCaregiverModal])
    let RefProviderPopup = useMemo(() => { return <OpenQuickPopup ID={RefproviderID + ""} name={'RefProvider'} setPopup={setPopup} popupName={'RefProvider'} type={"Label"} /> }, [mainCaregiverModal])
    return (
        <>
            {isLoading ? <Loader /> : null}
            <div className="tabs-container screen-size">
                <div className="min-h-inherit d-flex flex-column justify-content-between">
                    <div className="row g-0 demograpics_screen_size">
                        <div className="col-md-4 br-clr br-right-1 position-relative">
                            <div className="p-3">
                                <div className='row justify-content-between'>
                                    <div className="patient-profile-img col-md-4">
                                        <div class="img-container circle s-100">
                                            {mainCaregiverModal.ProfilePicture ? (<img src={mainCaregiverModal.ProfilePicture} alt="" />
                                            ) : (<img src="https://www.w3schools.com/howto/img_avatar.png" alt="" />)}
                                        </div>
                                        <div class="upload-patient-img  ">
                                            <label class="d-flex align-items-center  gap-10">
                                                <input type="file"
                                                    id="ProfilePicture"
                                                    name="ProfilePicture"
                                                    onChange={handleCaregiverProfileChange} />
                                                <i class="bi bi-camera-fill  lh-1" />
                                            </label>
                                        </div>
                                        {/* <div class="upload-patient-img  ">
                                            <input type="file" id="upload-patient-img"/>
                                            <label for="upload-patient-img" class="d-flex align-items-center  gap-10">
                                                <i class="bi bi-camera-fill  lh-1"></i>
                                            </label>
                                        </div> */}
                                    </div>

                                    <div className='col-md-6'>
                                        <div class="form-check form-switch radio_button hk-active__btn">
                                            <label class="form-check-label" for="mySwitch">Active</label>
                                            <input
                                                class="form-check-input"
                                                type="checkbox"
                                                id="mySwitch"
                                                name="Statuss"
                                                checked={mainCaregiverModal.Statuss}
                                                onChange={handleCaregiverChange}
                                            />
                                        </div>
                                        <div className='form-group input flex-grow-1 mt-3'>
                                            <label >Account #</label>
                                            <input
                                                type="text"
                                                className='form-control'
                                                name="AccountNumber"
                                                id="AccountNumber"
                                                value={mainCaregiverModal.AccountNumber}
                                                onChange={handleCaregiverChange}
                                                onKeyPress={(event) => handleNumericCheck(event)}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className='input'>
                                            <label htmlFor="">Department</label>
                                            <SuperSearchList
                                                type="client"
                                                id='Departments'
                                                name='Departments'
                                                searchValue={mainCaregiverModal.Departments}
                                                data={DropdownData?.Department}
                                                onChange={handleChangeDD}
                                                getSelectedData={handleSelectedData}
                                                is={is}
                                                icon={'Simple'}
                                                sup_btn='sup_btn-Inp'
                                                sup_inp='superSearchVisitInp'
                                            />
                                        </div>
                                        {/* <div className='form-group input'>
                                            <label >Department</label>
                                            <select
                                                className='form-control'
                                                id='Departments'
                                                name='Departments'
                                                value={mainCaregiverModal.Departments}
                                                onChange={handleCaregiverChange}
                                            >
                                                {DropdownData?.Department?.map((e, index) => (
                                                    <option value={e.value} key={index}>
                                                        {e.display}
                                                    </option>
                                                ))}
                                            </select>
                                        </div> */}
                                    </div>
                                    <div className="col-md-6">
                                        <div className='input'>
                                            <label >Primary Office <span className='req'>*</span></label>
                                            {/* <div className={CaregiverValidationModal.FirstNameVal ? 'form-group input error' : 'form-group input'}>
                                            <input type="text"
                                                className='form-control'
                                                name="PrimaryOffice"
                                                id="PrimaryOffice"
                                                maxLength={35}
                                                // onKeyPress={handleAlphabeticCheck}
                                                value={mainCaregiverModal.PrimaryOffice}
                                                onChange={handleCaregiverChange}
                                                onBlur={handleGenderCheck}
                                            />
                                            {CaregiverValidationModal.FirstNameVal}
                                        </div> */}
                                            <SuperSearchList
                                                type="client"
                                                id='PrimaryOffice'
                                                name='PrimaryOffice'
                                                searchValue={mainCaregiverModal.PrimaryOffice}
                                                data={DropDowns.Location}
                                                onChange={handleChangeDD}
                                                getSelectedData={handleSelectedData}
                                                is={is}
                                                sup_btn='sup_btn-Inp'
                                                sup_inp='superSearchVisitInp'
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="input">
                                            <label >Last Name <span className='req'>*</span></label>
                                            <div className={CaregiverValidationModal.LastNameVal ? 'form-group input error' : 'form-group input'}>

                                                <input type="text"
                                                    className='form-control'
                                                    name="LastName"
                                                    id="LastName"
                                                    maxLength={35}
                                                    onKeyPress={handleAlphabeticCheck}
                                                    value={mainCaregiverModal.LastName}
                                                    onChange={handleCaregiverChange}
                                                />
                                                {CaregiverValidationModal.LastNameVal}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className='input'>
                                            <label >First Name <span className='req'>*</span></label>
                                            <div className={CaregiverValidationModal.FirstNameVal ? 'form-group input error' : 'form-group input'}>
                                                <input type="text"
                                                    className='form-control'
                                                    name="FirstName"
                                                    id="FirstName"
                                                    maxLength={35}
                                                    // onKeyPress={handleAlphabeticCheck}
                                                    value={mainCaregiverModal.FirstName}
                                                    onChange={handleCaregiverChange}
                                                    onBlur={handleGenderCheck}
                                                />
                                                {CaregiverValidationModal.FirstNameVal}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="row">
                                <div className="col-md-6">
                                    <div className="input">
                                        <label >Medicaid # </label>
                                        <div className= 'form-group input'>

                                            <input type="text"
                                                className='form-control'
                                                name="MedicaidNo"
                                                id="MedicaidNo"
                                                maxLength={35}
                                                onKeyPress={handleAlphabeticCheck}
                                                value={mainCaregiverModal.MedicaidNo}
                                                onChange={handleCaregiverChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className='input'>
                                        <label >Medicare # </label>
                                        <div className= 'form-group input'>
                                            <input type="text"
                                                className='form-control'
                                                name="MedicareNo"
                                                id="MedicareNo"
                                                maxLength={35}
                                                value={mainCaregiverModal.MedicareNo}
                                                onChange={handleCaregiverChange}
                                                onBlur={handleGenderCheck}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className={CaregiverValidationModal.GenderVal ? 'form-group input error' : 'form-group input'}>
                                            <label >Gender<span className='req'>*</span></label>
                                            {/* <select
                                                className='form-control'
                                                id='Gender'
                                                name='Gender'
                                                value={mainCaregiverModal.Gender}
                                                onChange={handleCaregiverChange}
                                            >
                                                {Gender.map((e, index) => (
                                                    <option value={e.value} key={index}>
                                                        {e.display}
                                                    </option>
                                                ))}
                                            </select> */}
                                            {/* <div className='input'> */}
                                            {/* <label htmlFor="">Department</label> */}
                                            <SuperSearchList
                                                type="client"
                                                id='Gender'
                                                name='Gender'
                                                searchValue={mainCaregiverModal.Gender}
                                                data={Gender}
                                                onChange={handleChangeDD}
                                                getSelectedData={handleSelectedData}
                                                is={is}
                                                icon={'Simple'}
                                                sup_btn='sup_btn-Inp'
                                                sup_inp='superSearchVisitInp'
                                            />
                                            {/* </div> */}
                                            {CaregiverValidationModal.GenderVal}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className='input'>
                                            <label >Marital Status</label>
                                            <SuperSearchList
                                                type="client"
                                                id='MaritalStatus'
                                                name='MaritalStatus'
                                                searchValue={mainCaregiverModal.MaritalStatus}
                                                data={MaritalStatus}
                                                onChange={handleChangeDD}
                                                getSelectedData={handleSelectedData}
                                                is={is}
                                                icon={'Simple'}
                                                sup_btn='sup_btn-Inp'
                                                sup_inp='superSearchVisitInp'
                                            />
                                            {/* <select
                                                className='form-control'
                                                id='MaritalStatus'
                                                name='MaritalStatus'
                                                value={mainCaregiverModal.MaritalStatus}
                                                onChange={handleCaregiverChange}
                                            >
                                                {MaritalStatus.map((e, index) => (
                                                    <option value={e.value} key={index}>
                                                        {e.display}
                                                    </option>
                                                ))}
                                            </select> */}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className='form-group input'>
                                            <label >Dependents</label>
                                            <input
                                                type="text"
                                                className='form-control'
                                                name="Dependents"
                                                id="Dependents"
                                                maxLength={35}
                                                onKeyPress={handleAlphabeticCheck}
                                                value={mainCaregiverModal.Dependents}
                                                onChange={handleCaregiverChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className='form-group input'>
                                            <label >Alt. Caregiver Code</label>
                                            <input
                                                type="text"
                                                className='form-control'
                                                name="AltCaregiverCode"
                                                id="AltCaregiverCode"
                                                maxLength={35}
                                                onKeyPress={handleAlphabeticCheck}
                                                value={mainCaregiverModal.AltCaregiverCode}
                                                onChange={handleCaregiverChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="row">
                                <div className="col-md-6">
                                    <div className='form-group input'>
                                        <label >Previous Name</label>
                                        <input
                                            type="text"
                                            className='form-control'
                                            name="PreviousName"
                                            id="PreviousName"
                                            maxLength={35}
                                            onKeyPress={handleAlphabeticCheck}
                                            value={mainCaregiverModal.PreviousName}
                                            onChange={handleCaregiverChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className='form-group input'>
                                        <label >Preferred Name</label>
                                        <input
                                            type="text"
                                            className='form-control'
                                            name="PreferredName"
                                            id="PreferredName"
                                            maxLength={35}
                                            onKeyPress={handleAlphabeticCheck}
                                            value={mainCaregiverModal.PreferredName}
                                            onChange={handleCaregiverChange}
                                        />
                                    </div>
                                </div>
                            </div> */}
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className={CaregiverValidationModal.DateOfBirthVal ? 'form-group input error' : 'form-group input'}>
                                            <label htmlFor="dobInput">DOB<span className='req'>*</span></label>
                                            <DatePicker
                                                id="dobInput"
                                                value={mainCaregiverModal.DateOfBirth}
                                                handleCalendarChangefunc={date => handleCalendarChange(date, 'DateOfBirth')}
                                            />
                                            {CaregiverValidationModal.DateOfBirthVal}

                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className='form-group input'>
                                            <label >Age</label>
                                            <input type="text"
                                                className='form-control'
                                                name="Age"
                                                id="Age"
                                                readOnly
                                                value={mainCaregiverModal.Age}
                                            />
                                        </div>
                                    </div>
                                    {/* <div className="col-md-12">
                                    <div className='form-group input'>
                                        <label >Maiden Last Name</label>
                                        <input type="text"
                                            className='form-control'
                                            name="MaidenLastName"
                                            id="MaidenLastName"
                                            maxLength={35}
                                            onKeyPress={handleAlphabeticCheck}
                                            value={mainCaregiverModal.MaidenLastName}
                                            onChange={handleCaregiverChange}
                                        />
                                    </div>
                                </div> */}
                                </div>
                                <div className="row">
                                    {/* <div className="col-md-6"> */}
                                    {/* <div className='form-group input'>
                                        <label >MI</label>
                                        <div className={CaregiverValidationModal.MIval ? 'form-group input error' : 'input'}>
                                            <input type="text"
                                                className='form-control'
                                                name="MI"
                                                id="MI"
                                                maxLength={3}
                                                onKeyPress={handleAlphabeticCheck}
                                                value={mainCaregiverModal.MI}
                                                onChange={handleCaregiverChange}
                                            />
                                            {CaregiverValidationModal.MIval}
                                        </div>
                                    </div> */}
                                    {/* </div> */}
                                    <div className="col-md-6">
                                        <div className={CaregiverValidationModal.SSNLengthVal || CaregiverValidationModal.SSNval ? 'form-group input error' : 'form-group input'}>
                                            <label >SSN</label>
                                            <input type="text"
                                                className='form-control'
                                                name="SSN"
                                                id="SSN"
                                                maxLength={9}
                                                value={mainCaregiverModal.SSN}
                                                onKeyPress={(event) => handleNumericCheck(event)}
                                                onChange={handleCaregiverChange}
                                            />
                                            {CaregiverValidationModal.SSNLengthVal || CaregiverValidationModal.SSNval}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-8">
                            <div className="app-accordian pb-5">
                                <Accordion expanded={expanded === 'Pateint1-content'} onChange={handleChangeAccodian('Pateint1-content')}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="Pateint1-content"
                                        id="address-header"
                                    >
                                        <p className="heading">Address Information</p>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <div className='row row-gap-15 row-half'>
                                            <div className="col-md-6">
                                                <div className='input'>
                                                    <label htmlFor="">Address Line 1</label>
                                                    <input type="text" className='form-control'
                                                        name="AddressLine1"
                                                        id="AddressLine1"
                                                        value={mainCaregiverModal.AddressLine1}
                                                        onChange={handleCaregiverChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className='input'>
                                                    <label htmlFor="">Address Line 2</label>
                                                    <input type="text" className='form-control'
                                                        name="AddressLine2"
                                                        id="AddressLine2"
                                                        value={mainCaregiverModal.AddressLine2}
                                                        onChange={handleCaregiverChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className='row row-half mt-2'>
                                                    <div className="col-md-3">
                                                        <div className='input'>
                                                            <label htmlFor="">City</label>
                                                            <input type="text" className='form-control'
                                                                name="City"
                                                                id="City"
                                                                maxLength={30}
                                                                value={mainCaregiverModal.City}
                                                                onChange={handleCaregiverChange}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className='input'>
                                                            <label htmlFor="">State</label>
                                                            <SuperSearchList
                                                                type="client"
                                                                id='State'
                                                                name='State'
                                                                searchValue={mainCaregiverModal.State}
                                                                data={States}
                                                                onChange={handleChangeDD}
                                                                getSelectedData={handleSelectedData}
                                                                is={is}
                                                                sup_btn='sup_btn-Inp'
                                                                sup_inp='superSearchVisitInp'
                                                            // filterWith="startsWith"
                                                            // tableHeight="200px"
                                                            // tableWidth="100%"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className='form-group input'>
                                                            <label htmlFor="">Zip Code</label>
                                                            <div className={CaregiverValidationModal.ZipCodeVal || CaregiverValidationModal.ZipCodeLengthVal ? 'input error' : 'input'}>
                                                                <input type="text" className='form-control'
                                                                    name="ZipCode"
                                                                    id="ZipCode"
                                                                    autoComplete="off"
                                                                    maxLength={9}
                                                                    value={mainCaregiverModal.ZipCode}
                                                                    onKeyPress={(event) => handleNumericCheck(event)}
                                                                    onChange={handleCaregiverChange}
                                                                />
                                                                {CaregiverValidationModal.ZipCodeVal || CaregiverValidationModal.ZipCodeLengthVal}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className='form-group input'>
                                                            <label >Home Phone Number</label>
                                                            <div className={CaregiverValidationModal.HomePhoneNumberlen ? 'input error' : 'input'}>
                                                                <input
                                                                    type="text"
                                                                    className='form-control'
                                                                    name="HomePhoneNumber"
                                                                    id="HomePhoneNumber"
                                                                    placeholder="555-555-5555"
                                                                    value={mainCaregiverModal.HomePhoneNumber}
                                                                    onKeyPress={(event) => handleNumericCheck(event)}
                                                                    onChange={handleCaregiverChange}
                                                                />
                                                                {CaregiverValidationModal.HomePhoneNumberlen}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3 ">
                                                        <div className='form-group input'>
                                                            <label >Mobile Number</label>
                                                            <div className={CaregiverValidationModal.MobileNumberlen ? 'input error' : 'input'}>
                                                                <input
                                                                    type="text"
                                                                    className='form-control'
                                                                    name="MobileNumber"
                                                                    id="MobileNumber"
                                                                    placeholder="(555) 555-5555"
                                                                    value={mainCaregiverModal.MobileNumber}
                                                                    onKeyPress={(event) => handleNumericCheck(event)}
                                                                    onChange={handleCaregiverChange}
                                                                />
                                                                {CaregiverValidationModal.MobileNumberlen}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3 " >
                                                        <div className='form-group input'>
                                                            <label >Work Number</label>
                                                            <div className={CaregiverValidationModal.WorkNumberlen ? 'input error' : 'input'}>
                                                                <input
                                                                    type="text"
                                                                    className='form-control'
                                                                    name="WorkNumber"
                                                                    id="WorkNumber"
                                                                    placeholder="(555) 555-5555"
                                                                    value={mainCaregiverModal.WorkNumber}
                                                                    onKeyPress={(event) => handleNumericCheck(event)}
                                                                    onChange={handleCaregiverChange}
                                                                />
                                                                {CaregiverValidationModal.WorkNumberlen}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3 ">
                                                        <div className='form-group input'>
                                                            <label >Work Phone Extension</label>
                                                            <div className={CaregiverValidationModal.WorkPhoneExtentionlen ? 'input error' : 'input'}>
                                                                <input
                                                                    type="text"
                                                                    className='form-control'
                                                                    name="WorkPhoneExtention"
                                                                    id="WorkPhoneExtention"
                                                                    maxLength={4}
                                                                    value={mainCaregiverModal.WorkPhoneExtention}
                                                                    onKeyPress={(event) => handleNumericCheck(event)}
                                                                    onChange={handleCaregiverChange}
                                                                />
                                                                {CaregiverValidationModal.WorkPhoneExtentionlen}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3 ">
                                                        <div className='form-group input'>
                                                            <label >Other Phone Number</label>
                                                            <div className={CaregiverValidationModal.OtherPhoneNumberlen ? 'input error' : 'input'}>
                                                                <input
                                                                    type="text"
                                                                    className='form-control'
                                                                    name="OtherPhoneNumber"
                                                                    id="OtherPhoneNumber"
                                                                    placeholder="(555) 555-5555"
                                                                    value={mainCaregiverModal.OtherPhoneNumber}
                                                                    onKeyPress={(event) => handleNumericCheck(event)}
                                                                    onChange={handleCaregiverChange}
                                                                />
                                                                {CaregiverValidationModal.OtherPhoneNumberlen}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3 ">
                                                        <div className='form-group input'>
                                                            <label >Email</label>
                                                            <div className={CaregiverValidationModal.EmailAddressVal ? 'input error' : 'input'}>
                                                                <input
                                                                    type="text"
                                                                    className='form-control'
                                                                    name="Email"
                                                                    id="Email"
                                                                    maxLength={50}
                                                                    value={mainCaregiverModal.Email}
                                                                    onChange={handleCaregiverChange}
                                                                />
                                                                {CaregiverValidationModal.EmailAddressVal}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3 ">
                                                        <div className='form-group input'>
                                                            <label >Fax Number</label>
                                                            <div className={CaregiverValidationModal.FaxNumberlen ? 'input error' : 'input'}>
                                                                <ReactInputMask
                                                                    maskChar={0}
                                                                    mask='999-999-9999'
                                                                    className='form-control'
                                                                    name="FaxNumber"
                                                                    id="FaxNumber"
                                                                    value={mainCaregiverModal.FaxNumber}
                                                                    onKeyPress={(event) => handleNumericCheck(event)}
                                                                    onChange={handleCaregiverChange}
                                                                />
                                                                {CaregiverValidationModal.FaxNumberlen}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3 ">
                                                        <div className='input'>
                                                            <label >Primary Contact Type</label>
                                                            <SuperSearchList
                                                                type="client"
                                                                id='PrimaryContactType'
                                                                name='PrimaryContactType'
                                                                searchValue={mainCaregiverModal.PrimaryContactType}
                                                                data={PrimaryContactType}
                                                                onChange={handleChangeDD}
                                                                getSelectedData={handleSelectedData}
                                                                is={is}
                                                                sup_btn='sup_btn-Inp'
                                                                sup_inp='superSearchVisitInp'
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3 ">
                                                        <div className='input'>
                                                            <label >Preferred Language</label>
                                                            <SuperSearchList
                                                                type="client"
                                                                id='PreferredLanguage'
                                                                name='PreferredLanguage'
                                                                searchValue={mainCaregiverModal.PreferredLanguage}
                                                                data={PreferredLanguage}
                                                                onChange={handleChangeDD}
                                                                getSelectedData={handleSelectedData}
                                                                is={is}
                                                                sup_btn='sup_btn-Inp'
                                                                sup_inp='superSearchVisitInp'
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3 ">
                                                        <div className='input'>
                                                            <label >Preferred Communication</label>
                                                            <SuperSearchList
                                                                type="client"
                                                                id='PreferredCommunication'
                                                                name='PreferredCommunication'
                                                                searchValue={mainCaregiverModal.PreferredCommunication}
                                                                data={PreferredCommunication}
                                                                onChange={handleChangeDD}
                                                                getSelectedData={handleSelectedData}
                                                                is={is}
                                                                sup_btn='sup_btn-Inp'
                                                                sup_inp='superSearchVisitInp'
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3 ">
                                                        <div className='input'>
                                                            <label >EVV Language</label>
                                                            <SuperSearchList
                                                                type="client"
                                                                id='EVVLanguage'
                                                                name='EVVLanguage'
                                                                searchValue={mainCaregiverModal.EVVLanguage}
                                                                data={PreferredCommunication}
                                                                onChange={handleChangeDD}
                                                                getSelectedData={handleSelectedData}
                                                                is={is}
                                                                sup_btn='sup_btn-Inp'
                                                                sup_inp='superSearchVisitInp'
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion defaultExpanded>
                                    <AccordionSummary
                                        aria-hidden='true'
                                        id="prac1-header"
                                        aria-controls="prac1-content"
                                        expandIcon={<ExpandMoreIcon />}
                                    >
                                        <p className="heading">Employement Info <span className='text fs-11 ar-light-color fst-italic font-m'>Active First D/W: N/A Last D/W: N/A</span></p>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <div className='row row-half'>
                                            <div className="col-md-3">
                                                <div className={`form-group input ${CaregiverValidationModal.EmployementStatusval ? 'error' : ''}`}>
                                                    <label >Status</label>
                                                    <SuperSearchList
                                                        type="client"
                                                        id='EmployementStatus'
                                                        name='EmployementStatus'
                                                        searchValue={mainEmployementInfoCaregiverModal.EmployementStatus}
                                                        data={PreferredCommunication}
                                                        onChange={handleChangeDD}
                                                        getSelectedData={handleEmployementInfoSelectedData}
                                                        is={is}
                                                        sup_btn='sup_btn-Inp'
                                                        sup_inp='superSearchVisitInp'
                                                        inputError={CaregiverValidationModal.EmployementStatusval}
                                                    />
                                                    {CaregiverValidationModal.EmployementStatusval}
                                                </div>
                                            </div>
                                            <div className={`col-md-3 form-group input ${CaregiverValidationModal.EmployementDateval ? 'error' : ''}`}>
                                                <DatePicker
                                                    label='Date'
                                                    value={mainEmployementInfoCaregiverModal.Date}
                                                    handleCalendarChangefunc={date => handleEmployementInfoCalendarChange(date, 'Date')}
                                                />
                                                {CaregiverValidationModal.EmployementDateval}
                                            </div>
                                            <div className="col-md-3">
                                                <div className='form-group input'>
                                                    <label >Discipline</label>
                                                    <SuperSearchList
                                                        type="client"
                                                        id='Discipline'
                                                        name='Discipline'
                                                        searchValue={mainEmployementInfoCaregiverModal.Discipline}
                                                        data={disciplineData}
                                                        onChange={handleChangeDD}
                                                        getSelectedData={handleEmployementInfoSelectedData}
                                                        is={is}
                                                        sup_btn='sup_btn-Inp'
                                                        sup_inp='superSearchVisitInp'
                                                    />
                                                </div>
                                            </div>
                                            <div className='row row-half'>
                                                <div className="form-group input col-md-12">
                                                    <label htmlFor="Description">Notes</label>
                                                    <textarea
                                                        className="form-control doc-textarea"
                                                        id="Notes"
                                                        name="Notes"
                                                        value={mainEmployementInfoCaregiverModal.Notes}
                                                        onChange={handleEmployementInfoCaregiverDataChange}
                                                    ></textarea>
                                                </div>
                                                <div className='admition-table hk-expand-table BorderLess-table'>
                                                    <table>
                                                        <thead>
                                                            <tr>
                                                                <th className='heading'>Status</th>
                                                                <th className='heading'>Date</th>
                                                                <th className='heading'>Discipline</th>
                                                                <th className='heading'>Notes</th>
                                                                <th></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {mainCaregiverModal?.OtherData?.length > 0 ?
                                                                mainCaregiverModal?.OtherData?.map((item, index) => (
                                                                    <tr>
                                                                        <td className='text font-m Active'>Active</td>
                                                                        <td className='text'>{item.Date}</td>
                                                                        <td className='text'>{item.Discipline ? DropdownValueHandler(disciplineData, item.Discipline) : ''}</td>
                                                                        <td className='text'>{item.Notes}</td>
                                                                        <td className='text'>
                                                                            <i className='icon-delete' onClick={() => handleDeleteEmployementInfo(item, index)}></i>
                                                                        </td>
                                                                    </tr>
                                                                )) : <></>}
                                                            {/* <tr>
                                                            <td className='text font-m Hold'>Hold</td>
                                                            <td className='text'>5/2/2024</td>
                                                            <td className='text'>Returned from vacation</td>
                                                            <td className='text'>xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx</td>
                                                            <td className='text'>
                                                                <i className='icon-delete'></i>
                                                            </td>
                                                        </tr> */}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion defaultExpanded>
                                    <AccordionSummary
                                        aria-hidden='true'
                                        id="prac1-header"
                                        aria-controls="prac1-content"
                                        expandIcon={<ExpandMoreIcon />}
                                    >
                                        <p className="heading">Emergency Contact Information</p>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <div className='row row-half'>
                                            {popup}
                                            <div className="col-md-3">
                                                <div className='form-group input'>
                                                    <label >Name</label>
                                                    <div className={CaregiverValidationModal.EmergencyNameVal ? 'input error' : 'input'}>
                                                        <input
                                                            type="text"
                                                            className='form-control'
                                                            name="EmergencyName"
                                                            id="EmergencyName"
                                                            value={mainCaregiverModal.EmergencyName}

                                                            onChange={handleCaregiverChange}
                                                        />
                                                        {CaregiverValidationModal.EmergencyNameVal}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className='form-group input'>
                                                    <div className={CaregiverValidationModal.EmergencyRelationshipVal ? 'input error' : 'input'}>
                                                        <label >Relationship</label>
                                                        <SuperSearchList
                                                            type="client"
                                                            id='Relationship'
                                                            name='Relationship'
                                                            searchValue={mainEmployementInfoCaregiverModal.Relationship}
                                                            data={Relationship}
                                                            onChange={handleChangeDD}
                                                            getSelectedData={handleEmployementInfoSelectedData}
                                                            is={is}
                                                            sup_btn='sup_btn-Inp'
                                                            sup_inp='superSearchVisitInp'
                                                            inputError={CaregiverValidationModal.EmergencyRelationshipVal}
                                                        />
                                                        {CaregiverValidationModal.EmergencyRelationshipVal}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className='input'>
                                                    <label htmlFor="">Address</label>
                                                    <input type="text" className='form-control'
                                                        name="EmergencyAddress"
                                                        id="EmergencyAddress"
                                                        value={mainCaregiverModal.EmergencyAddress}
                                                        onChange={handleCaregiverChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className='form-group input'>
                                                    <label >Phone Number</label>
                                                    <div className={CaregiverValidationModal.EmergencyPhoneNumberlen ? 'input error' : 'input'}>
                                                        <input
                                                            type="text"
                                                            className='form-control'
                                                            name="EmergencyPhoneNumber"
                                                            id="EmergencyPhoneNumber"
                                                            placeholder="(555) 555-5555"
                                                            value={mainCaregiverModal.EmergencyPhoneNumber}
                                                            onKeyPress={(event) => handleNumericCheck(event)}
                                                            onChange={handleCaregiverChange}
                                                        />
                                                        {CaregiverValidationModal.EmergencyPhoneNumberlen}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className='form-group input'>
                                                    <label >Other Phone Number</label>
                                                    <div className={CaregiverValidationModal.EmergencyOtherPhoneNumberlen ? 'input error' : 'input'}>
                                                        <input
                                                            type="text"
                                                            className='form-control'
                                                            name="EmergencyOtherPhoneNumber"
                                                            id="EmergencyOtherPhoneNumber"
                                                            placeholder="(555) 555-5555"
                                                            value={mainCaregiverModal.EmergencyOtherPhoneNumber}
                                                            onKeyPress={(event) => handleNumericCheck(event)}
                                                            onChange={handleCaregiverChange}
                                                        />
                                                        {CaregiverValidationModal.EmergencyOtherPhoneNumberlen}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion expanded={expanded === 'other'} onChange={handleChangeAccodian('other')}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="other-content"
                                        id="other-header"
                                    >
                                        <p className="heading">Other Information</p>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <div className='row row-half'>

                                            <div className="col-md-6">
                                                <div className="input race">
                                                    <label htmlFor="">Race</label>
                                                    {/* <Autocomplete
                                                    multiple
                                                    id="Race"
                                                    name='Race'
                                                    value={race}
                                                    // limitTags={3}
                                                    options={Races}
                                                    fullWidth={true}
                                                    getOptionLabel={(option) => option.display}
                                                    noOptionsText={"Not Available"}
                                                    onChange={(event, value) => handleMultipleSelect(value, 'Race')}
                                                    renderInput={(params) => <TextField {...params} variant="standard" onChange={handleChangeDD} />}
                                                /> */}
                                                    <SuperSearchList
                                                        type="client"
                                                        id="Race"
                                                        name='Race'
                                                        searchValue={mainCaregiverModal.Race}
                                                        data={Races}
                                                        onChange={handleChangeDD}
                                                        getSelectedData={handleSelectedData}
                                                        is={is}
                                                        sup_btn='sup_btn-Inp'
                                                        sup_inp='superSearchVisitInp'
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="input">
                                                    <label htmlFor="">Ethnicity</label>
                                                    {/* <div className='input-group'> */}
                                                    {/* <Autocomplete
                                                        multiple
                                                        id="Ethnicity"
                                                        name='Ethnicity'
                                                        value={ethnicity}
                                                        // limitTags={3}
                                                        options={Ethnicity}
                                                        fullWidth={true}
                                                        getOptionLabel={(option) => option.display}
                                                        noOptionsText={"Not Available"}
                                                        onChange={(event, value) => handleMultipleSelect(value, 'Ethnicity')}
                                                        renderInput={(params) => <TextField {...params} variant="standard" onChange={handleChangeDD} />}
                                                    /> */}
                                                    <SuperSearchList
                                                        type="client"
                                                        id="Ethnicity"
                                                        name='Ethnicity'
                                                        searchValue={mainCaregiverModal.Ethnicity}
                                                        data={Ethnicity}
                                                        onChange={handleChangeDD}
                                                        getSelectedData={handleSelectedData}
                                                        is={is}
                                                        sup_btn='sup_btn-Inp'
                                                        sup_inp='superSearchVisitInp'
                                                    />
                                                    {/* </div> */}
                                                </div>
                                                {/* <div className='input'>
                                                    <label>Ethnicity</label>
                                                    <SuperSearchList
                                                        type="client"
                                                        id='Ethnicity'
                                                        name='Ethnicity'
                                                        searchValue={mainCaregiverModal.Ethnicity}
                                                        data={Ethnicity}
                                                        onChange={handleChangeDD}
                                                        getSelectedData={handleSelectedData}
                                                        is={is}
                                                        sup_btn='sup_btn-Inp'
                                                        sup_inp='superSearchVisitInp'
                                                    // filterWith="startsWith"
                                                    // tableHeight="200px"
                                                    // tableWidth="100%"
                                                    />
                                                </div> */}
                                            </div>
                                            {/* <div className="col-md-3 mt-2">
                                            <div className='input'>
                                                <label htmlFor="">Employment Status</label>
                                                <select
                                                    className='form-control'
                                                    id='EmploymentStatus'
                                                    name='EmploymentStatus'
                                                    value={mainCaregiverModal.EmploymentStatus}
                                                    onChange={handleCaregiverChange}
                                                >
                                                    {EmploymentStatus.map((e, index) => (
                                                        <option value={e.value} key={index}>
                                                            {e.display}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div> */}
                                            {/* <div className="col-md-3 mt-2">
                                            <div className='input'>
                                                <label htmlFor="">Student Status</label>
                                                <select
                                                    className='form-control'
                                                    id='StudentStatus'
                                                    name='StudentStatus'
                                                    value={mainCaregiverModal.StudentStatus}
                                                    onChange={handleCaregiverChange}
                                                >
                                                    {/* <option>{CoveragePriority.display}</option> */}
                                            {/* {StudentStatus.map((e, index) => (
                                                        <option value={e.value} key={index}>
                                                            {e.display}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        // </div> */}
                                            {/* <div className="col-md-3 mt-2">
                                            <div className='input'>
                                                <label htmlFor="">Class</label>
                                                <select
                                                    className='form-control'
                                                    id='Class'
                                                    name='Class'
                                                    value={mainCaregiverModal.Class}
                                                    onChange={handleCaregiverChange}
                                                >
                                                    {/* <option>{CoveragePriority.display}</option> */}
                                            {/* {Class.map((e, index) => (
                                                        <option value={e.value} key={index}>
                                                            {e.value}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div> */}
                                            {/* <div className="col-md-3 mt-2">
                                            <div className='input'>
                                                <label>Birth City</label>
                                                <input
                                                    type="text"
                                                    className='form-control'
                                                    name="BirthCity"
                                                    id="BirthCity"
                                                    value={mainCaregiverModal.BirthCity}
                                                    onChange={handleCaregiverChange}
                                                />
                                            </div>
                                        </div> */}
                                            {/* <div className="col-md-3 mt-2">
                                            <div className='input'>
                                                <label htmlFor="">Birth Order</label>
                                                <select
                                                    className='form-control'
                                                    id='BirthOrder'
                                                    name='BirthOrder'
                                                    value={mainCaregiverModal.BirthOrder}
                                                    onChange={handleCaregiverChange}
                                                > */}
                                            {/* <option>{CoveragePriority.display}</option> */}
                                            {/* {BirthOrder.map((e, index) => (
                                                        <option value={e.value} key={index}>
                                                            {e.value}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div> */}
                                            {/* <div className="col-md-3 mt-2">
                                            <div className='input'>
                                                <label htmlFor="">Gender Identity</label>
                                                <select
                                                    className='form-control'
                                                    id='GenderIdentity'
                                                    name='GenderIdentity'
                                                    value={mainCaregiverModal.GenderIdentity}
                                                    onChange={handleCaregiverChange}
                                                > */}
                                            {/* <option>{CoveragePriority.display}</option> */}
                                            {/* {GenderIdentity.map((e, index) => (
                                                        <option value={e.value} key={index}>
                                                            {e.value}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div> */}
                                            {/* <div className="col-md-3 mt-2">
                                            <div className='input'>
                                                <label htmlFor="">Sexual Orientation</label>
                                                <select
                                                    className='form-control'
                                                    id='SexualOrientation'
                                                    name='SexualOrientation'
                                                    value={mainCaregiverModal.SexualOrientation}
                                                    onChange={handleCaregiverChange}
                                                > */}
                                            {/* <option>{CoveragePriority.display}</option> */}
                                            {/* {SexualOrientation.map((e, index) => (
                                                        <option value={e.value} key={index}>
                                                            {e.value}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div> */}
                                            {/* <div className="col-md-3 mt-2">
                                            <DatePicker
                                                label='Date Of Death'
                                                value={mainCaregiverModal.DateOfDeath}
                                                handleCalendarChangefunc={date => handleCalendarChange(date, 'DateOfDeath')}
                                            />
                                        </div> */}
                                            {/* <div className="col-md-3 mt-2">
                                            <div className='input'>
                                                <label>Cause of Death</label>
                                                <input
                                                    type="text"
                                                    className='form-control'
                                                    name="CauseOfDeath"
                                                    id="CauseOfDeath"
                                                    value={mainCaregiverModal.CauseOfDeath}
                                                    onChange={handleCaregiverChange}
                                                />
                                            </div>
                                        </div> */}
                                            {/* <div className="col-md-3 mt-2">
                                            <div className='input'>
                                                <label>Caregiver Referral Source</label>
                                                <select className='form-control'>
                                                    <option>Option</option>
                                                </select>
                                            </div>
                                        </div> */}
                                            {/* <div className="col-md-3 mt-2">
                                            <div className='input'>
                                                <label htmlFor="">Blood Group</label>
                                                <select
                                                    className='form-control'
                                                    id='BloodGroup'
                                                    name='BloodGroup'
                                                    value={mainCaregiverModal.BloodGroup}
                                                    onChange={handleCaregiverChange}
                                                > */}
                                            {/* <option>{CoveragePriority.display}</option> */}
                                            {/* {BloodGroup.map((e, index) => (
                                                        <option value={e.value} key={index}>
                                                            {e.value}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div> */}
                                            {/* <div className="col-md-3 mt-2">
                                            <div className='input'>
                                                <label>Mother’s First Name</label>
                                                <input
                                                    type="text"
                                                    className='form-control'
                                                    name="MotherFirstName"
                                                    id="MotherFirstName"
                                                    value={mainCaregiverModal.MotherFirstName}
                                                    onChange={handleCaregiverChange}
                                                />
                                            </div>
                                        </div> */}
                                            {/* <div className="col-md-3 mt-2">
                                            <div className='input'>
                                                <label>Mother’s Median Name</label>
                                                <input
                                                    type="text"
                                                    className='form-control'
                                                    name="MotherMedianName"
                                                    id="MotherMedianName"
                                                    value={mainCaregiverModal.MotherMedianName}
                                                    onChange={handleCaregiverChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-3 mt-2">
                                            <div className='input'>
                                                <label>Hispanic or Latino</label>
                                                <select className='form-control'>
                                                    <option>Option</option>
                                                </select>
                                            </div>
                                        </div> */}

                                            {/* <div className="col-md-12 mt-2">
                                            <div className='d-flex gap-3 flex-wrap'>
                                                <div className="form-check custom_check_box   form-check-inline d-flex gap-10 align-items-center">
                                                    <input type="checkbox"
                                                        className="form-check-input mt-0"
                                                        name="MultipleBirth"
                                                        id="MultipleBirth"
                                                        checked={mainCaregiverModal.MultipleBirth}
                                                        onChange={handleCaregiverChange}
                                                    />
                                                    <label className="form-check-label" for="inlineCheckbox1">Multiple Birth</label>
                                                </div>
                                                <div className="form-check custom_check_box   form-check-inline d-flex gap-10 align-items-center">
                                                    <input type="checkbox"
                                                        className="form-check-input mt-0"
                                                        name="Pregnancy"
                                                        id="Pregnancy"
                                                        checked={mainCaregiverModal.Pregnancy}
                                                        onChange={handleCaregiverChange}
                                                    />
                                                    <label className="form-check-label" for="inlineCheckbox2">Pregnancy</label>
                                                </div>
                                                <div className="form-check  custom_check_box   form-check-inline d-flex gap-10 align-items-center">
                                                    <input type="checkbox"
                                                        className="form-check-input mt-0"
                                                        name="IsDeceased"
                                                        id="IsDeceased"
                                                        checked={mainCaregiverModal.IsDeceased}
                                                        onChange={handleCaregiverChange}
                                                    />
                                                    <label className="form-check-label" for="inlineCheckbox3">Is Deceased </label>
                                                </div>
                                                <div className="form-check custom_check_box   form-check-inline d-flex gap-10 align-items-center">
                                                    <input type="checkbox"
                                                        className="form-check-input mt-0"
                                                        name="SignatureOnFile"
                                                        id="SignatureOnFile"
                                                        checked={mainCaregiverModal.SignatureOnFile}
                                                        onChange={handleCaregiverChange}
                                                    />
                                                    <label className="form-check-label" for="inlineCheckbox4">Signature on File</label>
                                                </div>
                                                <div className="form-check custom_check_box   form-check-inline d-flex gap-10 align-items-center">
                                                    <input type="checkbox"
                                                        className="form-check-input mt-0"
                                                        name="ReleaseOfFile"
                                                        id="ReleaseOfFile"
                                                        checked={mainCaregiverModal.ReleaseOfFile}
                                                        onChange={handleCaregiverChange}
                                                    />
                                                    <label className="form-check-label" for="inlineCheckbox4">Release of File</label>
                                                </div>
                                            </div>
                                        </div> */}

                                        </div>
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                            {isOpenMissing &&
                                <div className='missing_detail'>
                                    <div className='demo missing_data'>
                                        <span className='d-flex align-items-center'>
                                            <span class="icon-Group-4785"><span class="path1 fs-18"></span><span class="path2 "></span><span class="path3 "></span></span>
                                            Demographic have some data missing <span className='detail border-0'><i className=' cursor-pointer ms-5 icon-Icon-metro-cross' onClick={() => setIsOpenMissing(false)}></i></span>
                                        </span>
                                        <div className='message_list'>
                                            {missingDataInfo.map((item) => {
                                                return (
                                                    <p className='text'>{item}</p>
                                                )
                                            })}
                                            {/* <p className='text'>Caregiver Address is missing.</p>
                                            <p className='text'>Caregiver DateOfBirth is missing.</p>
                                            <p className='text'>Caregiver Address is missing.</p> */}
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                    <div className='tabs-action-bottom br-top-1 br-bottom-1 br-clr justify-content-between d-flex py-2'>
                        <div className='col-md-3'>
                            <div className='ms-3 py-1'>
                                <p className='heading heading_ext'>Created By/Date: <span className='text text_color'>{!isNull(mainCaregiverModal.CreatedBy) ? mainCaregiverModal.CreatedBy + ',' + mainCaregiverModal.CreatedDate : 'N/A'}</span></p>
                            </div>
                        </div>
                        <div className='col-md-3'>
                            <div className="position-relative">
                                {CaregiverID > 0 ? <>
                                    {isNull(mainCaregiverModal.ErrorMessages) ?
                                        <div className='demo mt-1'>
                                            <span > <i className='icon-check-circle'></i> Demographics are complete</span>
                                        </div>
                                        :
                                        <div className='demo missing_data'>
                                            <span className='d-flex align-items-center'>
                                                <span class="icon-Group-4785"><span class="path1 fs-18"></span><span class="path2 "></span><span class="path3 "></span></span>
                                                Demographic have some data missing <span className='detail cursor-pointer' onClick={handleOpenMissingData}><i className='icon-arrow-right2'></i></span>
                                            </span>
                                        </div>
                                    }
                                </> : null}
                            </div>
                        </div>
                        <div className='col-md-3'>
                            <div className='btns-group text-end px-3  d-flex align-items-center justify-content-end py-1'>
                                <button className={IsEditAllowed ? 'btn btn-orange m-0' : 'btn btn-orange m-0 disabled'} onClick={handleSaveCaregiver}>Save</button>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Demographics
